<template>
  <div style="overflow-y: hidden">
    <div class="landNavbar" id="fixed">
      <!-- brand design -->
      <div class="flexNav" id="landingLogo">
        <router-link
          :to="{
            name: 'Landingpage',
          }"
          class="flexLogo"
        >
          <img
            src="@/assets/landingLogo.svg"
            width="237"
            height="49"
            alt="main page logo"
          />
        </router-link>
      </div>

      <!-- profile design -->
      <div class="flexNav" id="navigation">
        <a class="landingButton" href="#contact">Contact Us</a>
        <!--:to="{
                name: 'Contact',
            }"-->
        <router-link
          class="landingButton"
          :to="{
            name: 'EmailLandingPage',
          }"
          >Schools</router-link
        >
        <router-link
          class="landingButton"
          :to="{
            name: 'Login',
          }"
          >Login</router-link
        >

        <router-link
          class="landingButton"
          :to="{
            name: 'Signup',
          }"
          >Sign up</router-link
        >
        <div class="hamburgerMenu">
          <input id="hamburgerBox" type="checkbox" />

          <span class="hamburgerLayer" id="firstLayer"></span>
          <span class="hamburgerLayer" id="secondLayer"></span>
          <span class="hamburgerLayer" id="thirdLayer"></span>

          <ul id="smallMenu">
            <router-link
              class="smallLandingButton"
              :to="{
                name: 'EmailLandingPage',
              }"
              >Schools</router-link
            >
            <router-link
              class="smallLandingButton"
              :to="{
                name: 'Login',
              }"
              >Login</router-link
            >

            <router-link
              class="smallLandingButton"
              :to="{
                name: 'Signup',
              }"
              >Sign up</router-link
            >

            <div id="contact" class="navbarBottom">
              <div class="totalContact contactLeft">
                <a
                  href="https://apps.apple.com/ca/app/courselnk/id1545799969"
                  class="appstore"
                  target="_blank"
                ></a>
                <a
                  href="https://facebook.com/courselnk"
                  class="facebook"
                  target="_blank"
                ></a>

                <a
                  href="https://instagram.com/courselnk"
                  class="instagram"
                  target="_blank"
                ></a>

                <a
                  href="https://linkedin.com/company/71220107"
                  class="linkedin"
                  target="_blank"
                ></a>
                <a
                  href="mailto:support@courselnk.com"
                  class="email"
                  target="_blank"
                ></a>
              </div>
            </div>
          </ul>
        </div>
      </div>
    </div>

    <div id="mainBody" style="background: #f5f6f7; padding-bottom: 50px;">
      <div class="boxed center contestBox">
        <div class="contestTitle">
          <p class="bigText">Win airpods in a giveaway!</p>
        </div>
        <div class="contestHeader">
          <div>
            <img
              src="@/assets/apple-airpods.png"
              alt="Giveaway image"
              class="giveawayImg"
            />
          </div>
          <div class="daysLeft">
            <div class="loginTitle">{{ this.numDays }}</div>
            <div class="smallLoginTitle">Days left</div>
          </div>
        </div>
        <p class="bigText enterBox">
          5 ways to enter
        </p>
        <div class="contestBody">
          <div style="width: 100%;">
            <div class="buttonRow">
              <img
                src="@/assets/contestRules/contestTag.png"
                class="contestImgs"
                alt="Tag 3 friends"
              />
              <p class="greenText">
                Tag three friends on our latest instagram post
              </p>
              <template v-if="tag">
                <a
                  href="https://www.instagram.com/p/CUBCBlxvNWa/"
                  target="_blank"
                >
                  <div class="numberEntries">
                    Done!
                  </div>
                </a>
              </template>
              <template v-else>
                <a
                  href="https://www.instagram.com/p/CUBCBlxvNWa/"
                  target="_blank"
                  ><div class="numberEntries" @click="completedTask(0)">
                    +1 Entries
                  </div></a
                >
              </template>
            </div>
            <div class="buttonRow">
              <img
                src="@/assets/contestRules/contestPost.png"
                class="contestImgs"
                alt="Post on story"
              />
              <p class="greenText">
                Post about us on your story
              </p>
              <template v-if="post">
                <a
                  href="https://www.instagram.com/p/CUBCBlxvNWa/"
                  target="_blank"
                  ><div class="numberEntries">
                    Done!
                  </div>
                </a>
              </template>
              <template v-else>
                <a
                  href="https://www.instagram.com/p/CUBCBlxvNWa/"
                  target="_blank"
                >
                  <div class="numberEntries" @click="completedTask(1)">
                    +5 Entries
                  </div>
                </a>
              </template>
            </div>
            <div class="buttonRow">
              <img
                src="@/assets/contestRules/contestAccount.png"
                class="contestImgs"
                alt="Create CourseLnk account"
              />
              <p class="greenText">Create a courselnk account</p>
              <template v-if="account">
                <a href="https://courselnk.com/signup" target="_blank">
                  <div class="numberEntries">
                    Done!
                  </div></a
                >
              </template>
              <template v-else>
                <a href="https://courselnk.com/signup" target="_blank">
                  <div class="numberEntries" @click="completedTask(2)">
                    +3 Entries
                  </div>
                </a>
              </template>
            </div>
            <div class="buttonRow">
              <img
                src="@/assets/contestRules/contestProgress.png"
                class="contestImgs"
                alt="Progress bar"
              />
              <p class="greenText">
                Complete your CourseLnk profile
              </p>
              <template v-if="progress">
                <a href="https://courselnk.com/profile" target="_blank">
                  <div class="numberEntries">
                    Done!
                  </div></a
                >
              </template>
              <template v-else>
                <a href="https://courselnk.com/profile" target="_blank">
                  <div class="numberEntries" @click="completedTask(3)">
                    +2 Entries
                  </div>
                </a>
              </template>
            </div>
            <div class="buttonRow">
              <img
                src="@/assets/contestRules/contestFriends.png"
                class="contestImgs"
                alt="invite friends"
              />
              <p class="greenText">
                Refer a friend
              </p>
              <div
                class="numberEntries"
                style="pointer-events: none; box-shadow: none"
              >
                +10 Entries per referral
              </div>
            </div>
            <div style="margin-left: 30px">
              <p class="greenText">
                1.) Your referral code is your school email
              </p>
              <div class="buttonRow queryButtonRow">
                <div class="secondButtonRow">
                  <p class="greenText">
                    2.) Use your referral link
                  </p>
                </div>
                <template v-if="loadingLink">
                  <div class="numberEntries">
                    <div class="loader"></div>
                  </div>
                  <p v-if="feedback" class="feedback">{{ feedback }}</p>
                </template>
                <template v-else>
                  <template v-if="link == ''">
                    <div class="emailContainer">
                      <input
                        class="emailInput"
                        v-model="email"
                        placeholder="Enter email for link"
                      />
                      <p v-if="feedback" class="feedback">{{ feedback }}</p>
                      <div
                        class="numberEntries"
                        @click="getEmail()"
                        style="margin-left: 0"
                      >
                        Get Link
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="numberEntries" style="pointer-events: none">
                      {{ this.link }}
                    </div>
                  </template>
                </template>
              </div>
            </div>
          </div>
        </div>
        <p class="bigText enterBox">
          Additional rules
        </p>
        <div class="contestBody">
          <div>
            <div class="buttonRow">
              <div class="greenText">1.</div>
              <p class="ruleText">
                In order to be eligible for the contest you must be following
                @courselnk on instagram.
              </p>
            </div>
            <div class="buttonRow">
              <div class="greenText">2.</div>
              <div class="ruleText">
                There are five ways to earn entries to the giveaway:
                <p>
                  <span style="padding: 10px;">•</span>
                  Tagging 3 friends on our Instagram post = 1 entry
                </p>
                <p>
                  <span style="padding: 10px;">•</span> Create an account = 3
                  entries
                </p>
                <p>
                  <span style="padding: 10px;">•</span> Set up your profile = 2
                  entries
                </p>
                <p>
                  <span style="padding: 10px;">•</span> Referring a user using
                  your signup email = 10 entries
                </p>
                <p>
                  <span style="padding: 10px;">•</span> Sharing the contest post
                  to your instagram story = 5 entries
                </p>
              </div>
            </div>
            <div class="buttonRow">
              <div class="greenText">3.</div>
              <p class="ruleText">
                There is no limit to the number of entries you can earn for the
                giveaway.
              </p>
            </div>
            <div class="buttonRow">
              <div class="greenText">4.</div>
              <p class="ruleText">
                Entries received after Sunday October 3rd, 2021 at 11:59 PM EST
                will not be counted
              </p>
            </div>
            <div class="buttonRow">
              <div class="greenText">5.</div>
              <p class="ruleText">
                The winners will be selected on instagram livestream on Thursday
                October 4th, 2021 at 5:00PM EST.
              </p>
            </div>
            <div class="buttonRow">
              <div class="greenText">6.</div>
              <p class="ruleText">
                The winners will be contacted via email or Instagram.
              </p>
            </div>
            <div class="buttonRow">
              <div class="greenText">7.</div>
              <p class="ruleText">
                The winners must respond within 48 hours or new winners will be
                selected.
              </p>
            </div>
            <p>*Must have a residence outside of Quebec, no fee for entry</p>
            <div
              class="numberEntries termsConditionsButton"
              @click="goToTerms()"
            >
              Terms and Conditions
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "@/firebase";
import { mapState } from "vuex";
export default {
  data: () => ({
    numDays: 0,
    tag: false,
    post: false,
    account: false,
    progress: false,
    feedback: "",
    email: "",
    link: "",
    loadingLink: false,
  }),

  computed: {
    ...mapState("user", ["contest"]),
  },

  mounted() {
    this.getNumDays();
    this.tag = this.contest[0];
    this.post = this.contest[1];
    this.account = this.contest[2];
    this.progress = this.contest[3];
  },

  methods: {
    getNumDays() {
      var timeLeft = 1633276740000 - Date.now();
      this.numDays = Math.ceil(timeLeft / 86400000);
    },
    completedTask(index) {
      this.contest[index] = true;
      this.tag = this.contest[0];
      this.post = this.contest[1];
      this.account = this.contest[2];
      this.progress = this.contest[3];
      this.$store.commit("user/setContest", this.contest);
    },
    getEmail() {
      this.loadingLink = true;
      var getUserFromEmail = firebase
        .functions()
        .httpsCallable("getUserFromEmail");
      getUserFromEmail(this.email.replaceAll(" ", "")).then((data) => {
        if (data.data != null) {
          this.link = "https://courselnk.com/" + data.data.uid;
        } else {
          this.feedback =
            "Invalid email, please use the email you used to create your CourseLnk account";
        }
        this.loadingLink = false;
      });
    },
    goToTerms() {
      this.$router.push({ name: "ContestTerms" });
    },
  },
};
</script>

<style scoped src="@/styles/views/Ambassadors.css"></style>
